/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../../ISymbolData';
import StreakTrackerFilterBase from './StreakTrackerFilterBase';

/** Filter for symbols that are on an active payline. */
@cc._decorator.ccclass
export default class ActivePaylineFilter extends StreakTrackerFilterBase
{
    /** Filter out symbols that are not on active payline. */
    public Filter: (symbols: ISymbolData[]) => ISymbolData[]
            = (symbols: ISymbolData[]) => symbols.filter(x => x.IsActivePayline)
}
